export const deserializeTabularData = (keys, values) => {
  const serializedAcquisition = {};

  keys.forEach((key, index) => {
    serializedAcquisition[key] = values[index];
  });

  return serializedAcquisition;
};
